// parent-child relations

import { decorate, observable, action } from 'mobx'
import { INode, NodeId } from '../types'


export const NeomemParentChild = (SuperClass: any) => class extends SuperClass {

  // recursively delete down the parent child relations
  deleteNode(nodeId: NodeId): void {
    console.log('deletenode', nodeId)
    // recurse through child nodes and delete them from bottom up
    const node = this.getNode(nodeId)
    const childIds = node.childIds as string | undefined
    const childIdArray = childIds ? childIds.split(',') : []
    for (let childId of childIdArray) {
      this.deleteNode(childId)
    }
    return this.deleteNodeNorecurse(nodeId)
  }

  // remove a node from the store
  deleteNodeNorecurse(nodeId: NodeId): void {
    console.log('deletenodenorecurse', nodeId)
    // remove from parent-child relation, if any
    this.removeChild(nodeId)
    // remove from cache
    this.deleteCacheNode(nodeId)
    // notify subscribers
    // this.notify('deleteNode', nodeId)
    // tell db
    if (this.db) {
      this.db.deleteNode(nodeId)
    }
  }


  // add child to end of parent's children list
  // see also moveChild
  addChild(childId: NodeId, parentId: NodeId, beforeId?: NodeId): void {
    console.log('addchild', childId, parentId, beforeId)
    const child = this.getNode(childId)
    const parent = this.getNode(parentId)

    // remove from current place if any
    this.removeChild(childId)

    // add child to parent's childId list at correct location
    const childIds = parent.childIds as string | undefined
    const childIdArray = childIds ? childIds.split(',') : []
    if (beforeId === undefined) {
      childIdArray.push(childId)
    } else {
      const beforeIndex = childIdArray.indexOf(beforeId) //. what if -1?
      childIdArray.splice(beforeIndex, 0, childId)
    }
    const newChildIds = childIdArray.join(',')
    this.setNodeValue(parent.id, 'childIds', newChildIds)

    // set parentId
    this.setNodeValue(childId, 'parentId', parentId)

    // set depth recursively
    const depthDelta = (parent.depth as number | undefined || 0) + 1 - (child.depth as number | undefined || 0)
    const tree = this.getTree(childId)
    for (let node of tree) {
      const depth = (node.depth as number | undefined || 0)
      this.setNodeValue(node.id, 'depth', depth + depthDelta)
    }

    // // tell db
    // if (this.db && !child.system) {
    //   this.db.setNodeValue(parentId, 'childIds', newChildIds)
    //   this.db.setNodeValue(childId, 'parentId', parentId)
    //   for (let node of tree) {
    //     this.db.setNodeValue(node.id, 'depth', node.depth)
    //   }
    // }
  }

  // remove child from parent, but don't delete it - it's just detached from parentchild tree
  removeChild(childId: NodeId): void {
    console.log('removechild', childId)
    const oldParent = this.getParent(childId)
    if (oldParent) {
      const childIds = oldParent.childIds as string | undefined
      const childIdArray = childIds ? childIds.split(',') : []
      const newChildIdArray = childIdArray.filter(id => id !== childId)
      const newChildIds = newChildIdArray.join(',')
      this.deleteNodeValue(childId, 'parentId')
      this.setNodeValue(oldParent.id, 'childIds', newChildIds)
      // const child = this.getNode(childId)
      // if (this.db && !child.system) {
      //   // this.db.removeChild(child, oldParent)
      //   this.db.deleteNodeValue(childId, 'parentId')
      //   this.db.setNodeValue(oldParent.id, 'childIds', newChildIds)
      // }
    }
  }

  // move a child node - put in place of given node
  moveChild(fromId: NodeId, toId: NodeId, movingFromAbove: boolean): void {

    console.log('movechild', fromId, toId, movingFromAbove)

    const fromParent = this.getParent(fromId) // can be undefined
    const toParent = this.getParent(toId)

    if (fromParent === toParent) {
      const parent = fromParent
      console.log('movechild same parent', parent)
      if (parent) {
        const childIds = parent.childIds as string // can be undefined
        const childIdArray = childIds ? childIds.split(',') : [] // array of string ids
        const fromIndex = childIdArray.findIndex(id => id === fromId)
        const toIndex = childIdArray.findIndex(id => id === toId)
        let newChildIdArray = [...childIdArray]
        newChildIdArray.splice(fromIndex, 1)
        if (toIndex < newChildIdArray.length) {
          newChildIdArray.splice(toIndex, 0, fromId)
        } else {
          newChildIdArray.push(fromId)
        }
        const newChildIds = newChildIdArray.join(',')
        this.setNodeValue(parent.id, 'childIds', newChildIds)
        // tell db
        if (this.db) {
          this.db.setNodeValue(parent.id, 'childIds', newChildIds)
        }
      }
    } else {
      // this.moveChildDifferentParents(fromId, toId)
      console.log('movechild different parent', fromParent)
      // remove from source parent
      if (fromParent) {
        const childIds = fromParent.childIds as string | undefined
        const childIdArray = childIds ? childIds.split(',') : [] // array of string ids
        const newChildIdArray = childIdArray.filter(id => id !== fromId)
        const newChildIds = newChildIdArray.length > 0 ? newChildIdArray.join(',') : undefined
        this.setNodeValue(fromParent.id, 'childIds', newChildIds)
        // // tell db
        // if (this.db) {
        //   this.db.setNodeValue(fromParent.id, 'childIds', newChildIds)
        // }
      }
      // add to destination parent
      if (toParent) {
        const childIds = toParent.childIds as string | undefined // can be undefined
        const childIdArray = childIds ? childIds.split(',') : [] // array of string ids
        const toIndex = childIdArray.findIndex(id => id === toId) + (movingFromAbove ? 1 : 0)
        console.log(fromId, toIndex, movingFromAbove)
        const newChildIdArray = [...childIdArray]
        newChildIdArray.splice(toIndex, 0, fromId)
        const newChildIds = newChildIdArray.join(',')
        this.setNodeValue(fromId, 'parentId', toParent.id)
        this.setNodeValue(fromId, 'depth', (toParent.depth as number || 0) + 1)
        this.setNodeValue(toParent.id, 'childIds', newChildIds)
        // // tell db
        // if (this.db) {
        //   this.db.setNodeValue(fromId, 'parentId', toParent.id)
        //   this.db.setNodeValue(fromId, 'depth', (toParent.depth as number || 0) + 1)
        //   this.db.setNodeValue(toParent.id, 'childIds', newChildIds)
        // }
      }
    }
  }

  moveLeft(nodeId: NodeId): void {
    console.log('moveleft', nodeId)
    const node = this.getNode(nodeId)
    const parentId = node.parentId
    const parent = this.getNode(parentId)
    const gparentId = parent.parentId
    const newParentId = gparentId
    const nextSibling = this.getNextSibling(parentId)
    const nextSiblingId = nextSibling ? nextSibling.id : undefined
    this.addChild(nodeId, newParentId, nextSiblingId)
  }

  moveRight(nodeId: NodeId): void {
    console.log('moveright', nodeId)
    const prevSibling = this.getPrevSibling(nodeId)
    console.log(prevSibling)
    if (prevSibling) {
      const newParentId = prevSibling.id
      if (newParentId) {
        // const children = this.getChildren(newParentId)
        // const beforeChild = children[0] // undefined if no children
        // const beforeId = beforeChild ? beforeChild.id : undefined
        // this.addChild(nodeId, newParentId, beforeId)
        this.addChild(nodeId, newParentId, undefined) // add after last child of the new parent
      }
    }
  }

  //. dont like this proliferation of graph traversal methods, but any other soln?

  getNextSibling(nodeId: NodeId): INode | undefined {
    console.log('getnextsibling', nodeId)
    const node = this.getNode(nodeId)
    const parentId = node.parentId
    const siblings = this.getChildren(parentId)
    const index = siblings.findIndex(n => n.id === nodeId)
    const nextIndex = index >= 0 ? index + 1 : undefined
    const next = nextIndex && (nextIndex < siblings.length) ? siblings[nextIndex] : undefined
    return next
  }

  getPrevSibling(nodeId: NodeId): INode | undefined {
    console.log('getprevsibling', nodeId)
    const node = this.getNode(nodeId)
    const parentId = node.parentId
    const siblings = this.getChildren(parentId)
    const index = siblings.indexOf(node)
    const prevIndex = index > 0 ? index - 1 : undefined
    if (prevIndex === undefined) {
      return undefined
    }
    const prev = siblings[prevIndex]
    return prev
  }

  // get list of ordered child Nodes of parent
  // cf getNodes({parentId}), which is unordered
  getChildren(parentId: NodeId): INode[] {
    // console.log('getchildren', parentId)
    const childIds = this.getNodeValue(parentId, 'childIds') as string | undefined
    const childIdArray = childIds ? childIds.split(',') : []
    // const children = childIdArray.map(id => this.cache[id]) //. cache[id] could be undefined
    const children = childIdArray.map(id => this.getNode(id))
    return children
  }

  // get ordered tree of children Nodes recursively
  // hierarchy is implicit in each node's depth property
  getTree(parentId: NodeId): INode[] {
    // console.log('gettree', parentId)
    let tree: INode[] = []
    const node = this.getNode(parentId)
    if (node) tree.push(node)
    const children = this.getChildren(parentId)
    if (children) {
      children.forEach(child => {
        tree = tree.concat(this.getTree(child.id)) // recurse
      })
    }
    return tree
  }

  //. would want this or similar to handle the doc view
  //. note that this assumes a tree structure - so goes under parent-child reln fns?
  getTreeText(nodeId: NodeId): string {
    let text = ""
    const lf = "\n"
    const line = "--------------------------------------------------------------------------------"
    //. will want to retrieve all data from db, not just that in cache. ie fill cache first.
    const nodes = this.getTree(nodeId)
    nodes.forEach(node => {
      const indent = '='.repeat(node.depth as number || 0)
      let section = ''
      section += line + lf
      section += indent + ' ' + node.name + ' ' + indent + lf
      section += line + lf
      //. will need to move some of these to neomem-tripplanner
      section += "Type: " + (node.typeId || '') + lf
      if (node.subtypeId) section += "Subtype: " + (node.subtypeId || '') + lf
      if (node.typesStr) section += "GoogleType: " + (node.typesStr || '') + lf
      if (node.placeId) section += "GooglePlaceID: " + (node.placeId || '') + lf
      if (node.centerStr) section += "Center: " + (node.centerStr || '') + lf
      if (node.boundsStr) section += "Bounds: " + (node.boundsStr || '') + lf
      if (node.notes) section += "Notes: " + (node.notes || '') + lf
      section += lf + lf
      text += section
    })
    return text
  }

  hasChildren(parentId: NodeId): boolean {
    return this.getChildren(parentId).length > 0
  }

  getParent(childId: NodeId): INode | undefined {
    // console.log('getparent', childId)
    const child = this.getNode(childId)
    const parent = child.parentId ? this.getNode(child.parentId as string) : undefined
    return parent
  }

  getSiblings(nodeId: NodeId): INode[] {
    // console.log('getsiblings', nodeId)
    const parent = this.getParent(nodeId)
    const siblings = parent ? this.getChildren(parent.id) : []
    return siblings
  }

}


// for jest tests
if (process.env.NODE_ENV !== 'test') {
  decorate(NeomemParentChild, {
    addChild: action,
    removeChild: action,
    moveChild: action,
    moveChildLeft: action,
    moveChildRight: action,
    deleteNode: action,
    deleteNodeNorecurse: action,
  })
}
